import React, { useEffect, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa6';
import { useParams } from 'react-router-dom';

import {
  fieldObjectRepresentantesOuComunicacoes as fieldObject,
  headersComunicacoes,
  valoresExibidosComunicacoes as valoresExibidos,
} from './auxiliarFornecedores';
import SubAbasFornecedores from './subabasFornecedores';
import BarraInferiorBotoes from '../../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../../components/ContainerConteudo';
import CustomButton from '../../../../../components/CustomButton';
import CustomCol from '../../../../../components/CustomCol';
import CustomRow from '../../../../../components/CustomRow';
import Input from '../../../../../components/InputNew';
import Select from '../../../../../components/InputNew/Select';
import StyledLink from '../../../../../components/Link';
import Log from '../../../../../components/Log/Log';
import Modal from '../../../../../components/Modal';
import SubAbas from '../../../../../components/SubAbas';
import Tabela from '../../../../../components/Tabela';
import WorkspaceBotoes from '../../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../../components/WorkspaceFicha';
import {
  getUser,
  isActionAllowed,
} from '../../../../../modules/contexts/Auth/RequireAuth';
import { LogData } from '../../../../../modules/types/types';
import { useModuloUsuario } from '../../../../../services/enum/useModuloUsuario';
import { usePapelUsuario } from '../../../../../services/enum/usePapelUsuario';
import { useStatusEnvio } from '../../../../../services/enum/useStatusEnvio';
import { useTipoComunicacao } from '../../../../../services/enum/useTipoComunicacao';
import { useTopicoComunicacao } from '../../../../../services/enum/useTopicoComunicacao';
import { useUnidadeDAF } from '../../../../../services/enum/useUnidadeDaf';
import { getComunicacoesByFornecedor } from '../../../../../services/fornecedoresDAF/comunicacoesService';
import { getFornecedor } from '../../../../../services/fornecedoresDAF/fornecedorService';
import httpClient, { isHttpError } from '../../../../../services/httpClient';
import { ENTITY } from '../../../../../utils/entityNames';
import {
  ExportToExcel,
  formataNomeMeioSiglas,
  formatDate,
} from '../../../../../utils/functions';
import {
  swalAtualizacao,
  swalDelete,
  swalDeleteConfirm,
  swalErro,
  swalSave,
} from '../../../../../utils/swal';

//Dados do usuário
const user = getUser();
const userID = user.sub;
const entity = ENTITY.ENTITY_FornecedorComunicacao;

function FornecedoresComunicacoesIndex() {
  const params = useParams();
  const fichaID = String(params.id);

  // Dados do módulo
  const subAbas = SubAbasFornecedores(fichaID);
  const UnidadeDAF = useUnidadeDAF();
  const TipoComunicacao = useTipoComunicacao();
  const TopicoComunicacao = useTopicoComunicacao();
  const StatusEnvio = useStatusEnvio();

  const [showModal, setShowModal] = useState<boolean>(false);
  const [comunicacaoId, setComunicacaoId] = useState<string>('');
  const [updating, setUpdating] = useState<boolean>(false);
  const [logData, setLogData] = useState<LogData>();
  const [data, setData] = useState<any[]>([]);

  const [formComunicacao, setFormComunicacao] = useState({
    unidadeDAF: 0,
    tipoComunicacao: 0,
    topicoComunicacao: 0,
    statusEnvio: 0,
    dataEnvio: '',
    demandaOriginal: '',
    destinatario: '',
    assunto: '',
    mensagemEnviada: '',
    observacoes: '',

    // chave usuário
    usuarioRegistroId: userID,
    // chave fornecedor
    fornecedorId: parseInt(fichaID, 10),
  });

  const [formFornecedor, setFormFornecedor] = useState({
    fornecedorId: 0,
    cnpj: '',
    razaoSocial: '',
  });

  //Filtro
  const [formFiltros, setFormFiltros] = useState({
    unidadeDAF: 0,
    tipoComunicacao: 0,
    topicoComunicacao: 0,
    statusEnvio: 0,
    assunto: '',
    dataEnvio: '',
  });

  let tituloModal = '';
  if (updating) {
    tituloModal = 'Atualizar Registro';
  } else {
    tituloModal = 'Novo Registro';
  }
  const iconeModal = 'warehouse';

  // Buscar dados
  const fetchData = async (id: string) => {
    try {
      const comunicacoesData = await getComunicacoesByFornecedor(id);
      const fornecedorData = await getFornecedor(id);
      setData(comunicacoesData);
      setFormComunicacao({
        unidadeDAF: comunicacoesData.unidadeDAF,
        statusEnvio: comunicacoesData.statusEnvio,
        dataEnvio: comunicacoesData.dataEnvio,
        topicoComunicacao: comunicacoesData.topicoComunicacao,
        tipoComunicacao: comunicacoesData.tipoComunicacao,
        demandaOriginal: comunicacoesData.demandaOriginal,
        destinatario: comunicacoesData.destinatario,
        assunto: comunicacoesData.assunto,
        mensagemEnviada: comunicacoesData.mensagemEnviada,
        observacoes: comunicacoesData.observacoes,

        // chave usuário
        usuarioRegistroId: userID,
        // chave fornecedor
        fornecedorId: parseInt(fichaID, 10),
      });
      setFormFornecedor({
        fornecedorId: fornecedorData.id,
        cnpj: fornecedorData.cnpj,
        razaoSocial: fornecedorData.razaoSocial,
      });
      setLogData({
        id: comunicacoesData.id,
        usuarioRegistro: comunicacoesData.usuarioRegistro?.nomeCompleto || '',
        usuarioAtualizacao:
          comunicacoesData.usuarioAtualizacao?.nomeCompleto || '',
        dataRegistro: comunicacoesData.dataRegistro,
        dataAtualizacao: comunicacoesData.dataUltimaAtualizacao,
        nEdicoes: comunicacoesData.nEdicoes,
      });
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };
  useEffect(() => {
    fetchData(fichaID);
  }, []);

  //Dados da tabela
  const tableData = data
    .map((item) => ({
      id: item.id,
      unidadeDAF: UnidadeDAF[item.unidadeDAF].label,
      tipoComunicacao: TipoComunicacao[item.tipoComunicacao].label,
      topicoComunicacao: TopicoComunicacao[item.topicoComunicacao].label,
      assunto: item.assunto,
      status: StatusEnvio[item.statusEnvio].label,
      dataEnvio: item.dataEnvio || '',
    }))
    .filter((registro: any) => {
      return (
        (formFiltros.unidadeDAF == 0 ||
          registro.unidadeDAF == UnidadeDAF[formFiltros.unidadeDAF].label) &&
        (formFiltros.tipoComunicacao === 0 ||
          registro.tipoComunicacao ===
            TipoComunicacao[formFiltros.tipoComunicacao].label) &&
        (formFiltros.topicoComunicacao === 0 ||
          registro.topicoComunicacao ===
            TopicoComunicacao[formFiltros.topicoComunicacao].label) &&
        (formFiltros.assunto === '' ||
          registro.assunto
            .toLowerCase()
            .includes(formFiltros.assunto.toLowerCase())) &&
        (formFiltros.statusEnvio === 0 ||
          registro.status === StatusEnvio[formFiltros.statusEnvio].label) &&
        // Manter ou remover dataEnvio?
        (formFiltros.dataEnvio === '' ||
          registro.dataEnvio
            .toLowerCase()
            .includes(formFiltros.dataEnvio.toLowerCase()))
      );
    });

  //Dados do Offcanvas
  const offCanvasData = data.map((item) => ({
    id: item.id,
    dataRegistro:
      formatDate(item.dataRegistro) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
    dataUltimaAtualizacao:
      formatDate(item.dataUltimaAtualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),

    dataUltimaVisualizacao:
      formatDate(item.dataUltimaVisualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
    nEdicoes: item.nEdicoes,
    nVisualizacoes: item.nVisualizacoes,
    // tipoProduto: tipoProduto[item.tipoProduto].label,
    unidadeDAF: UnidadeDAF[item.unidadeDAF].label,
    tipoComunicacao: TipoComunicacao[item.tipoComunicacao].label,
    topicoComunicacao: TopicoComunicacao[item.topicoComunicacao].label,
    statusEnvio: StatusEnvio[item.statusEnvio].label,
    demandaOriginal: item.demandaOriginal,
    destinatario: item.destinatario,
    assunto: item.assunto,
    mensagemEnviada: item.mensagemEnviada,
    observacoes: item.observacoes,
  }));

  //Dados para exportação XLS
  const exportData = data.map((item) => ({
    //Dados da entidade
    id: item.id,
    unidadeDAF: UnidadeDAF[item.unidadeDAF].label,
    tipoComunicacao: TipoComunicacao[item.tipoComunicacao].label,
    topicoComunicacao: TopicoComunicacao[item.topicoComunicacao].label,
    statusEnvio: StatusEnvio[item.statusEnvio].label,
    demandaOriginal: item.demandaOriginal,
    destinatario: item.destinatario,
    assunto: item.assunto,
    mensagemEnviada: item.mensagemEnviada,
    observacoes: item.observacoes,

    //Dados do Fornecedor
    fornecedorId: formFornecedor.fornecedorId,
    cnpj: formFornecedor.cnpj,
    razaoSocial: formFornecedor.razaoSocial,

    //Logs
    dataRegistro: item.dataRegistro,
    dataUltimaAtualizacao: item.dataUltimaAtualizacao,
    dataUltimaVisualizacao: item.dataUltimaVisualizacao,
    usuarioRegistro: formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
    usuarioAtualizacao: formataNomeMeioSiglas(
      item.usuarioAtualizacao.nomeCompleto,
    ),
    usuarioUltimaVisualizacao: formataNomeMeioSiglas(
      item.usuarioUltimaVisualizacao.nomeCompleto,
    ),
    nEdicoes: item.nEdicoes,
    nVisualizacoes: item.nVisualizacoes,
  }));

  // Funções Handle
  const handleChangeForm = (e: any) => {
    const { name, value } = e.target;
    const newValue = parseInt(value, 10);
    if (name === 'unidadeDAF') {
      setFormComunicacao({
        ...formComunicacao,
        unidadeDAF: newValue,
      });
    } else if (name === 'tipoComunicacao') {
      setFormComunicacao({
        ...formComunicacao,
        tipoComunicacao: newValue,
      });
    } else if (name === 'topicoComunicacao') {
      setFormComunicacao({
        ...formComunicacao,
        topicoComunicacao: newValue,
      });
    } else if (name === 'statusEnvio') {
      setFormComunicacao({
        ...formComunicacao,
        statusEnvio: newValue,
      });
    } else {
      setFormComunicacao((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleChangeFiltros = (e: any) => {
    const { name, value } = e.target;
    if (name === 'unidadeDAF') {
      const newValue = parseInt(value, 10);
      setFormFiltros({
        ...formFiltros,
        unidadeDAF: newValue,
      });
    } else if (name === 'tipoComunicacao') {
      const newValue = parseInt(value, 10);
      setFormFiltros({
        ...formFiltros,
        tipoComunicacao: newValue,
      });
    } else if (name === 'topicoComunicacao') {
      const newValue = parseInt(value, 10);
      setFormFiltros({
        ...formFiltros,
        topicoComunicacao: newValue,
      });
    } else if (name === 'statusEnvio') {
      const newValue = parseInt(value, 10);
      setFormFiltros({
        ...formFiltros,
        statusEnvio: newValue,
      });
    } else {
      setFormFiltros((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleClearFiltros = () => {
    setFormFiltros({
      ...formFiltros,
      unidadeDAF: 0,
      tipoComunicacao: 0,
      topicoComunicacao: 0,
      assunto: '',
      statusEnvio: 0,
      dataEnvio: '',
    });
  };

  const handleClearForm = () => {
    setFormComunicacao({
      ...formComunicacao,
      unidadeDAF: 0,
      tipoComunicacao: 0,
      topicoComunicacao: 0,
      statusEnvio: 0,
      demandaOriginal: '',
      destinatario: '',
      assunto: '',
      mensagemEnviada: '',
      observacoes: '',

      // chave usuário
      usuarioRegistroId: userID,
      // chave fornecedor
      fornecedorId: parseInt(fichaID, 10),
    });
  };

  const handleShowModal = () => {
    setShowModal((show) => !show);
  };

  const handleClickInserirNovo = () => {
    handleClearForm();
    setUpdating(false);
    handleShowModal();
  };

  const handleRowClick = (id: string) => {
    setComunicacaoId(id);
    setUpdating(true);
    setShowModal(true);
    data
      .filter((item) => item.id == id)
      .map((item: any) => {
        setFormComunicacao({
          unidadeDAF: item.unidadeDAF,
          tipoComunicacao: item.tipoComunicacao,
          topicoComunicacao: item.topicoComunicacao,
          statusEnvio: item.statusEnvio,
          dataEnvio: item.dataEnvio,
          demandaOriginal: item.demandaOriginal,
          destinatario: item.destinatario,
          assunto: item.assunto,
          mensagemEnviada: item.mensagemEnviada,
          observacoes: item.observacoes,

          // chave usuário
          usuarioRegistroId: userID,
          // chave fornecedor
          fornecedorId: parseInt(fichaID, 10),
        });
        setLogData({
          id: item.id,
          usuarioRegistro: item.usuarioRegistro.nomeCompleto || '',
          usuarioAtualizacao: item.usuarioAtualizacao.nomeCompleto || '',
          dataRegistro: item.dataRegistro,
          dataAtualizacao: item.dataUltimaAtualizacao,
          nEdicoes: item.nEdicoes,
        });
      });
  };

  const handleCreate = async () => {
    try {
      // const token = 'JWT_SECRET';

      await httpClient.post(`/api/fornecedorcomunicacao`, formComunicacao);

      swalSave();
      fetchData(fichaID);
      setTimeout(() => handleShowModal(), 2500);
    } catch (error: any) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.registro.message);
      }
      console.error('Erro ao salvar registro:', error);
      console.log('Erro: ', error.message);
    }
  };

  const handleUpdate = async () => {
    try {
      const response = await httpClient.patch(
        `/api/fornecedorcomunicacao/${comunicacaoId}`,
        formComunicacao,
      );
      swalAtualizacao('Sucesso', response.data.message);
      fetchData(response.data.registroAtualizado.fornecedor.id);
      setTimeout(() => {
        setShowModal(false);
      }, 2000);
    } catch (error: any) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao atualizar dados', error);
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();

    if (result) {
      try {
        await httpClient.delete(`/api/fornecedorcomunicacao/${comunicacaoId}`);
        swalDeleteConfirm();
        fetchData(fichaID);
        setTimeout(() => {
          setShowModal(false);
        }, 2000);
      } catch (error) {
        if (isHttpError(error)) {
          swalErro(error.response?.data.message);
        }
        console.error('Erro ao excluir registro', error);
        swalErro('Não foi possível excluir o registro. Tente novamente.');
      }
    } else {
      swalErro('A operação falhou.');
    }
  };

  return (
    <>
      <SubAbas>
        <StyledLink
          to="/fornecedor/adm/fornecedores"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            // backgroundColor: '#E1ECFE',
            backgroundColor: '#C5D4EB',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <Modal
          icone={iconeModal}
          tituloModal={tituloModal}
          open={showModal}
          onHide={handleShowModal}
        >
          <WorkspaceFicha>
            <Log {...logData} />
            <CustomRow style={{ marginTop: '10px' }}>
              <CustomCol width="37%">
                <Input
                  name="assunto"
                  value={formComunicacao.assunto}
                  id="assunto"
                  label="Assunto"
                  onChange={handleChangeForm}
                />
              </CustomCol>
              <CustomCol width="15%">
                <Select
                  name="unidadeDAF"
                  value={formComunicacao.unidadeDAF}
                  options={UnidadeDAF}
                  onChange={handleChangeForm}
                  label="Unidade DAF"
                />
              </CustomCol>
              <CustomCol width="18%">
                <Select
                  name="tipoComunicacao"
                  value={formComunicacao.tipoComunicacao}
                  options={TipoComunicacao}
                  onChange={handleChangeForm}
                  label="Tipo de comunicação"
                  required
                />
              </CustomCol>
              <CustomCol width="30%">
                <Select
                  name="topicoComunicacao"
                  value={formComunicacao.topicoComunicacao}
                  options={TopicoComunicacao}
                  onChange={handleChangeForm}
                  label="Tópico da comunicação"
                  required
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol>
                <Input
                  name="demandaOriginal"
                  type="textarea"
                  value={formComunicacao.demandaOriginal}
                  id="demandaOriginal"
                  label="Demanda original"
                  onChange={handleChangeForm}
                  required
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol width="50%">
                <Input
                  name="destinatario"
                  value={formComunicacao.destinatario}
                  id="destinatario"
                  label="Destinatário"
                  onChange={handleChangeForm}
                  required
                />
              </CustomCol>
              <CustomCol width="25%">
                <Select
                  name="statusEnvio"
                  value={formComunicacao.statusEnvio}
                  options={StatusEnvio}
                  onChange={handleChangeForm}
                  label="Status do envio"
                />
              </CustomCol>
              <CustomCol width="25%">
                <Input
                  name="dataEnvio"
                  type="date"
                  value={formComunicacao.dataEnvio}
                  id="dataEnvio"
                  onChange={handleChangeForm}
                  label="Data do encaminhamento"
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol>
                <Input
                  name="mensagemEnviada"
                  type="textarea"
                  value={formComunicacao.mensagemEnviada}
                  id="mensagemEnviada"
                  label="Mensagem encaminhada"
                  onChange={handleChangeForm}
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol>
                <Input
                  id="observacoes"
                  type="textarea"
                  name="observacoes"
                  value={formComunicacao.observacoes}
                  label="Observações"
                  onChange={handleChangeForm}
                />
              </CustomCol>
            </CustomRow>
            <BarraInferiorBotoes>
              {updating ? (
                <WorkspaceBotoes
                  delete
                  onClickDelete={handleDelete}
                  save
                  onClickSave={handleUpdate}
                />
              ) : (
                <WorkspaceBotoes inserir onClickInserir={handleCreate} />
              )}
            </BarraInferiorBotoes>
          </WorkspaceFicha>
        </Modal>

        <BoxConteudo boxTitulo="Filtros" fechado>
          <CustomRow style={{ marginTop: '-15px' }}>
            <CustomCol width="14%">
              <Select
                name="unidadeDAF"
                value={formFiltros.unidadeDAF}
                options={UnidadeDAF}
                onChange={handleChangeFiltros}
                label="Unidade DAF"
              />
            </CustomCol>
            <CustomCol width="16%">
              <Select
                name="tipoComunicacao"
                value={formFiltros.tipoComunicacao}
                options={TipoComunicacao}
                onChange={handleChangeFiltros}
                label="Tipo de Comunicação"
              />
            </CustomCol>
            <CustomCol width="25%">
              <Select
                name="topicoComunicacao"
                value={formFiltros.topicoComunicacao}
                options={TopicoComunicacao}
                onChange={handleChangeFiltros}
                label="Tópico da Comunicação"
              />
            </CustomCol>
            <CustomCol width="15%">
              <Select
                name="statusEnvio"
                value={formFiltros.statusEnvio}
                options={StatusEnvio}
                onChange={handleChangeFiltros}
                label="Status"
              />
            </CustomCol>
            <CustomCol width="15%">
              <Input
                id="assunto"
                name="assunto"
                value={formFiltros.assunto}
                label="Assunto"
                onChange={handleChangeFiltros}
              />
            </CustomCol>
            <CustomCol width="15%">
              <Input
                id="dataEnvio"
                name="dataEnvio"
                value={formFiltros.dataEnvio}
                label="Data de envio"
                onChange={handleChangeFiltros}
              />
            </CustomCol>
          </CustomRow>
          <CustomRow style={{ marginTop: '-15px', textAlign: 'right' }}>
            <CustomCol className="mt-3 justify-content-end align-content-end">
              <CustomButton
                label="Limpar filtros"
                bgColor="#808080" // Cor cinza
                textColor="#ffffff" // Texto branco
                onClick={handleClearFiltros}
              />
            </CustomCol>
          </CustomRow>
        </BoxConteudo>

        <Tabela
          headers={headersComunicacoes}
          dataTable={tableData}
          dataOffCanvas={offCanvasData}
          displayValues={valoresExibidos}
          onRowClick={handleRowClick}
        />
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          download
          //  downloadDisabled={!canDownload}
          onClickDownload={() =>
            ExportToExcel(
              exportData,
              valoresExibidos,
              fieldObject,
              'fornecedores-comunicacoes.xlsx',
              userID,
              'DAF', // Nome da interface
              entity, // Nome da entidade
            )
          }
          inserir
          onClickInserir={handleClickInserirNovo}
        />
      </BarraInferiorBotoes>
    </>
  );
}

export default FornecedoresComunicacoesIndex;
